import type { ReactNode } from 'react'
import React from 'react'
import defaultStyles from './index.module.css'
import { getWindow } from '@ztechapps/common.utils'
import { Icon } from '../Icon'

export type AnchorTopProps = {
  icon?: string | ReactNode
  styles?: any
}

export const AnchorTop = (props: AnchorTopProps) => {
  const backToTopRef = React.useRef<any>(null)
  const window = getWindow()

  const icon = props.icon ?? <Icon name="arrow-up" />
  const styles = props.styles ?? defaultStyles

  React.useEffect(() => {
    const backToTopElem = backToTopRef.current

    if (backToTopElem) {
      const toggleBackToTop = () => {
        if (window.scrollY > 100) {
          backToTopElem.classList.add(styles.backToTopActive)
        } else {
          backToTopElem.classList.remove(styles.backToTopActive)
        }
      }
      window.addEventListener('load', toggleBackToTop)
      document.addEventListener('scroll', toggleBackToTop)
    }
  }, [backToTopRef.current])

  const scrollToTop = (e) => {
    e.preventDefault()
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <a
      ref={backToTopRef}
      className={`btn btn-primary  ${styles.backToTop}  d-flex align-items-center justify-content-center`}
      href="/"
      onClick={scrollToTop}
    >
      {icon}
    </a>
  )
}
